<template>
  <div class="custom-fav-notify-component">
    <div class="custom-fav-notify-component__img m-t-10 m-b-10">
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
        <g fill="none" fill-rule="evenodd">
          <path
            fill="#E40000"
            d="M20.277 17.27l-1.268 1.269-1.287-1.288c-1.374-1.37-3.178-2.051-4.981-2.051s-3.607.681-4.981 2.05c-2.748 2.74-2.745 7.197 0 9.938l10.566 10.551c.352.348.985.348 1.337 0 3.525-3.513 7.05-7.018 10.576-10.531 2.748-2.74 2.748-7.198 0-9.937-2.748-2.74-7.214-2.74-9.962 0z"
            transform="translate(6)"
          />
          <g stroke="#C8C8C8" stroke-linecap="round" stroke-width="2">
            <path d="M34.2 6.65L38 10.45" transform="translate(6) matrix(-1 0 0 1 72.2 0)" />
            <path d="M0 6.65L3.8 10.45" transform="translate(6)" />
            <path d="M19 0.95L19 4.75" transform="translate(6)" />
          </g>
        </g>
      </svg>
    </div>
    <div class="custom-fav-notify-component__message m-t-20 m-b-20 m-l-10 m-r-10">
      {{ message }}
    </div>

    <div>
      <app-link
        :route-to="{
          name: ROUTE_NAMES.FAVORITES,
          params: { vendor: getActiveVendor ? getActiveVendor.id : null }
        }"
        :use-accent-color="false"
        :disabled="!getActiveVendor"
        class="custom-fav-notify-component__link m-r-10"
      >
        View Favorites
      </app-link>
    </div>

    <button
      id="close-add-item-notify"
      class="custom-fav-notify-component__close m-t-20 m-b-20"
      aria-label="Close, item added to favorites notification"
    >
      <label class="iw-visuallyhidden" for="close-add-item-notify">Close, item added to favorites notification</label>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path
          fill="none"
          fill-rule="evenodd"
          stroke="#373737"
          stroke-linecap="square"
          stroke-width="2"
          d="M1.368 1.368l13.264 13.264m0-13.264L1.368 14.632"
        />
      </svg>
    </button>
    <p></p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ROUTE_NAMES } from "@/utils";
export default {
  name: "AppFavoriteNotifier",
  props: {
    messageId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      message: "",
      ROUTE_NAMES
    };
  },
  methods: {
    ...mapActions("messages", ["removeMessages"])
  },
  computed: {
    ...mapGetters({
      getMessage: "messages/getMessageById"
    }),
    ...mapGetters("vendor", ["getActiveVendor"])
  },
  mounted() {
    this.message = this.getMessage(this.messageId)["message"];
    this.removeMessages([this.messageId]);
  }
};
</script>

<style lang="scss">
.menu-itme-fav-notifier {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border: solid 1px #e3e3e3;
}
</style>
<style scoped lang="scss">
.custom-fav-notify-component {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background-color: $primary-color;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border: solid 1px #e3e3e3;
  color: #333;
  font-weight: 500;
  height: 70px;

  &__link {
    color: $favorites-notifier-color;
    text-decoration: none;
    font-size: 1em;
  }

  &__close {
    background-color: transparent;
    border: 0;
    cursor: pointer;
    position: relative;
    top: 2px;
    width: 26px;
  }

  @include respond-to-mobile {
    font-size: 0.9em;
  }
}
</style>
